var map = {
	"./beian.png": "7796",
	"./douyin.png": "a792",
	"./download.png": "96fc",
	"./foot_icon1.png": "664f",
	"./foot_icon2.png": "1c25",
	"./foot_icon3.png": "9e6e",
	"./foot_icon4.png": "efaa",
	"./load-err.png": "a513",
	"./logo.png": "9d64",
	"./logo_1.png": "014c",
	"./logo_2.png": "7db8",
	"./marker_1.png": "5bc0",
	"./marker_2.png": "0abe",
	"./miniprogram_car.png": "3ac7",
	"./newEnergy.png": "d3db",
	"./offiaccount.png": "e269",
	"./warranty_bg.png": "5c24"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d207";